import React, { useState } from "react";
import ContactUsImage from "../../assets/images/369X369.jpg";
import { WhatsappShareButton, WhatsappIcon } from "react-share";

const ContactImage = () => {
  return (
    <div className="col-md-6">
      <img src={ContactUsImage} alt="Contact Us" className="w-75" />
    </div>
  );
};

const handleInputFocus = (e) => {
  e.target.style.borderColor = "var(--primary-color)";
};

const handleInputBlur = (e) => {
  e.target.style.borderColor = "var(--third-color)";
};

const ContactUs = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const sharedContent = `
    الاسم: ${name}
    عنوان الرسالة: ${email}
    الرسالة: ${message}
  `;

  const handleSubmit = (e) => {
    e.preventDefault();
    // handle form submission here
  };

  const handleWhatsAppClick = () => {
    const number = "99092082";
    const whatsappURL = `https://wa.me/+965${number}?text=${encodeURIComponent(sharedContent)}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <div className="container my-3">
      <div className="row d-flex justify-content-center align-items-center">
        <div className="col-md-6">
          <h2
            className="text-center"
            style={{
              color: "var(--primary-color) ",
              fontWeight: "bold",
            }}
          >
            ارسل رسالة خاصة للحملة الانتخابية (نساء){" "}
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group mt-3">
              <label htmlFor="name" className="mb-2">
                {" "}
                الاسم
              </label>
              <input
                type="text"
                className="form-control shadow-none"
                id="name"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                required
              />
            </div>
            <div className="form-group mt-3">
              <label htmlFor="email" className="mb-2">
                {" "}
                عنوان الرسالة
              </label>
              <input
                type="email"
                className="form-control shadow-none"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                required
              />
            </div>
            <div className="form-group mt-3">
              <label htmlFor="message" className="mb-2">
                {" "}
                الرسالة
              </label>
              <textarea
                className="form-control shadow-none"
                id="message"
                name="message"
                rows="5"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                required
              />
            </div>
            <div className="d-flex justify-content-end w-100">
              <button
                type="submit"
                className="btn btn-outline-success mt-3"
                onClick={handleWhatsAppClick}
              >
                ارسال عبر WhatsApp
                <i className="fab fa-whatsapp mx-1"></i>
              </button>
            </div>
          </form>
        </div>
        <ContactImage />
      </div>
    </div>
  );
};

export default ContactUs;
